import React, { Component } from 'react';
import Helmet               from 'react-helmet';

import { Switch, Route }    from 'react-router-dom';

import HomePage             from './pages/HomePage';
import ContactPage          from './pages/ContactPage';
import AccountPage          from './pages/AccountPage';
import PrivacyPage          from './pages/PrivacyPage';
import TermsPage            from './pages/TermsPage';
import PartnersPage         from './pages/PartnersPage';
import NotFound             from './pages/NotFound';

import styles               from './app-styles.styl';

import './app.styl';

/**
 * The `App` component is the entry point for the react app.
 * It is rendered on the client as well as on the server.
 *
 * This is also the entry point for react router, declare any
 * of your top-level routes here.
 */
export default class App extends Component {

    render() {
        return (
            <div className={styles.App}>
                <Helmet>
                    <title>Roimax</title>
                </Helmet>

                <Switch>
                    <Route exact path='/'               component = {HomePage} />
                    <Route exact path='/contacts'       component = {ContactPage} />
                    <Route exact path='/create-account' component = {AccountPage} />
                    <Route exact path='/privacy-policy' component = {PrivacyPage} />
                    <Route exact path='/partners'       component = {PartnersPage} />
                    <Route exact path='/terms'          component = {TermsPage} />

                    <Route component={NotFound} />
                </Switch>
            </div>
        );
    }
}
